export const CustomizeMap = {
  nonepockets: "None Pockets",
  addpockets: "Add Pockets",
  kneelength: "Knee Length",
  tealength: "Tea Length",
  anklelength: "Ankle Length",
  floorlength: "Floor Length"
};
